import styled from "styled-components";


export const ContactContainer = styled.div`
    background:#fff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 30px;
    height: 500px;
    position: relative;
    z-index: 1;
`